module.exports = __webpack_public_path__ + "img/Space_Ship.24bc5374.png";